import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var MAX_RETRIES = 5,
    MAX_LETTER_RETRIES = 3;

function findSortedIndex(t, e) {
  var r,
      n,
      o = 0,
      s = t.length - 1;

  for (; o <= s;) {
    if (e > (n = t[r = (o + s) / 2 | 0]).high) o = r + 1;else {
      if (!(e < n.low)) return r;
      s = r - 1;
    }
  }

  return -1;
}

function getRandomItem(t, e) {
  return t[Math.floor(e() * t.length)];
}

var seedrandom = require("seedrandom");

function createModel(_x) {
  return _createModel.apply(this, arguments);
}

function _createModel() {
  _createModel = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(t) {
    var e,
        r,
        n,
        o,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            e = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            r = e.accuracy, n = "auto" === r ? 5 : r, o = {};
            return _context2.abrupt("return", (t.forEach(function (t) {
              for (var _e = 0; _e < t.length * n; _e++) {
                var _r2 = Math.floor(_e / n),
                    s = _r2 + _e % n + 1,
                    a = s - _r2,
                    i = t.substring(_r2, s),
                    h = t.substring(s, s + 1);

                if (a === i.length) {
                  var _e2 = s === t.length,
                      _n2 = 0 === _r2,
                      _a4 = o[i] || {
                    count: 0,
                    isLastLetter: _e2,
                    isStartLetter: _n2,
                    next: {},
                    nextSorted: []
                  };

                  _n2 && (_a4.isStartLetter = _n2), _e2 && (_a4.isLastLetter = _e2), h && (_a4.next[h] = _a4.next[h] || 0, _a4.next[h]++, _a4.count++), o[i] = _a4;
                }
              }
            }), Object.entries(o).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  t = _ref2[0],
                  e = _ref2[1];

              var r = 0;
              Object.entries(e.next).forEach(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    e = _ref4[0],
                    n = _ref4[1];

                var s = {
                  high: r + n,
                  letter: e,
                  low: r
                };
                r += n, o[t].nextSorted.push(s);
              });
            }), o));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createModel.apply(this, arguments);
}

function generateWord(t, e, r, n, o) {
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.random;
  var a = r.startLetters,
      i = r.accuracy,
      h = r.checkLastSlice,
      c = "auto" === i ? Math.max(Math.floor(e / 2), 1) : i;
  var l = 0,
      d = a ? a.toLowerCase() : getRandomItem(n, s);

  for (; d.length < e && l !== MAX_LETTER_RETRIES * e;) {
    var _r = void 0,
        _n = c;

    for (; !_r && _n > 0;) {
      var _o = t[d.slice(-_n)];
      _o && _o.count > e - d.length - 1 ? _r = _o : _n--;
    }

    if (!_r) break;

    var _a = s() * _r.count,
        _i = findSortedIndex(_r.nextSorted, _a);

    if (_i >= 0) {
      var _t = _r.nextSorted[_i].letter,
          _s = d.slice(-2) === "".concat(_t).concat(_t),
          _a2 = e - d.length == 1,
          _c = (d + _t).slice(-_n);

      if ((!_a2 || _a2 && (o.has(_c) || !h)) && !_s) {
        d += _t;
        continue;
      }
    }

    l += 1;
  }

  return d;
}

function generateWords(t, e, r) {
  var n = r.filteredWords,
      o = r.startLetters,
      s = r.minLength,
      a = r.maxLength,
      i = r.numWords,
      h = r.seed,
      c = a - s;
  if (!t) throw new Error("Model must exist: '".concat(t, "'"));
  if (c < 0) throw new Error("Min length '".concat(s, "' must be less then or equal to max length '").concat(a, "'"));
  if (s <= 0 || a <= 0) throw new Error("Min length '".concat(s, "' and max length '").concat(a, "' must be greater than zero"));
  if ("number" != typeof i || i <= 0) throw new Error("Num word must be a number and greater than zero: '".concat(i, "'"));
  if (o.length >= a) throw new Error("Start letters length '".concat(o.length, "' must be less than the max length '").concat(a, "'"));
  var l = h ? seedrandom(h) : Math.random,
      d = Object.keys(t).filter(function (e) {
    return t[e].isStartLetter && e.length <= s;
  }),
      u = new Set(Object.keys(t).filter(function (e) {
    return t[e].isLastLetter;
  })),
      f = new Set();
  var g = 0;

  for (; f.size !== i && g < MAX_RETRIES * i;) {
    var _o2 = c > 0 ? Math.round(c * l()) : 0,
        _a3 = s + _o2,
        _i2 = generateWord(t, _a3, r, d, u, l);

    n.has(_i2) || e.has(_i2) || f.has(_i2) || _i2.length < _a3 ? g += 1 : f.add(_i2);
  }

  return Array.from(f.values());
}

var Model =
/*#__PURE__*/
function () {
  function Model() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Model);

    if (this.options = Object.assign({
      accuracy: 1,
      checkLastSlice: !0,
      filteredWords: new Set(),
      maxLength: 12,
      minLength: 2,
      numWords: 1,
      startLetters: ""
    }, e), this.words = new Set(t.map(function (t) {
      return t.toLocaleLowerCase();
    })), 0 === this.words.size) throw new Error("No words were found");
  }

  _createClass(Model, [{
    key: "getModel",
    value: function getModel() {
      return this.model;
    }
  }, {
    key: "generate",
    value: function () {
      var _generate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var t,
            e,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.options;
                _context.t0 = this.model;

                if (_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return createModel(this.words, this.options);

              case 5:
                this.model = _context.sent;

              case 6:
                e = Object.assign({}, this.options, t);
                return _context.abrupt("return", generateWords(this.model, this.words, e));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generate() {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
  }]);

  return Model;
}();

export default Model;